var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer_guide" }, [
    _c(
      "a",
      {
        staticClass: "guide_item",
        class: { on: _vm.isCurrent("payment") },
        attrs: { href: "javascript:;" },
        on: {
          click: function($event) {
            return _vm.gotoPath("/payment")
          }
        }
      },
      [
        _c("span", { staticClass: "item_icon" }, [
          _c("i", {
            staticClass: "iconImg icon-index",
            class: { onImg: _vm.isCurrent("payment") }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("缴费查询")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "guide_item",
        class: { on: _vm.isCurrent("autpayment") },
        attrs: { href: "javascript:;" },
        on: {
          click: function($event) {
            return _vm.gotoPath("/autpayment")
          }
        }
      },
      [
        _c("span", { staticClass: "item_icon" }, [
          _c("i", {
            staticClass: "iconImg icon-autpayment",
            class: { onImg: _vm.isCurrent("autpayment") }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("缴费中心")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "guide_item",
        class: { on: _vm.isCurrent("reportrepair") },
        attrs: { href: "javascript:;" },
        on: {
          click: function($event) {
            return _vm.gotoPath("/reportrepair")
          }
        }
      },
      [
        _c("span", { staticClass: "item_icon" }, [
          _c("i", {
            staticClass: "iconImg icon-repair",
            class: { onImg: _vm.isCurrent("reportrepair") }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("供热报修")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "guide_item",
        class: { on: _vm.isCurrent("profile") },
        attrs: { href: "javascript:;" },
        on: {
          click: function($event) {
            return _vm.gotoPath("/profile")
          }
        }
      },
      [
        _c("span", { staticClass: "item_icon" }, [
          _c("i", {
            staticClass: "iconImg icon-profile",
            class: { onImg: _vm.isCurrent("profile") }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("我的")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bacdb21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bacdb21","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterNav/FooterNav.vue
// module id = null
// module chunks = 